const accordion = {
  props: {
    dynamicClass: ".accordion-toggle.dynamicLoading",
    cssSelectorItem: ".accordion-item",
    cssSelectorToggle: ".accordion-toggle-JS, .accordion-toggle",
    cssSelectorContent: "accordion-content",
    cssSelectorPD: "accordion-NotPD-JS",
    classNameActive: "active",
  },

  init: function (baseDom) {
    bcl.u.loadStyleSheet("/etc.clientlibs/barcelo/clientlibs/clientlib-accordion.css", this.props.dynamicClass);

    const baseElement = baseDom || document;
    baseElement.querySelectorAll(this.props.cssSelectorItem).forEach(this.initAccordionItem.bind(this));
    bcl.u.resize(this.resize.bind(this));

    const windowHash = window.location.hash;
    if (windowHash) {
      const decodedHash = decodeURIComponent(windowHash);
      const $accordionToggle = document.querySelector(`a${decodedHash}`);
      if ($accordionToggle) {
        const $tabContainer = $accordionToggle.closest(".cmp-tab-panel-JS");
        if ($tabContainer) {
          const $tabButton = document.getElementById(`tab-${$tabContainer.dataset.title}`);
          $tabButton?.click();
        }
        $accordionToggle.click();
      }
    }
  },

  initAccordionItem($accordionItem) {
    const $toggle = $accordionItem.querySelector(this.props.cssSelectorToggle);
    if ($toggle) {
      if (bcl.u.containsClass($accordionItem, "mod--v-menu") && !bcl.u.mobile.isMobile()) {
        this.toggle($accordionItem);
      }
      $toggle.addEventListener("click", this.click.bind(this));
      this.initAccesibilityAttributes($toggle, $accordionItem);
    }
  },
  initAccesibilityAttributes($toggle, $accordionItem) {
    if ($accordionItem) {
      const isExpanded = bcl.u.containsClass($accordionItem, this.props.classNameActive);
      $toggle.setAttribute("aria-expanded", isExpanded ? "true" : "false");
      const $content = $accordionItem.parentNode?.querySelector("." + this.props.cssSelectorContent);
      this.toogleFocusHidden($accordionItem, $content);
    }
    $toggle.setAttribute("role", "button");
    $toggle.addEventListener("keydown", function (e) {
      if (e.keyCode == 13 || e.keyCode == 32) {
        e.preventDefault();
        $toggle.click();
      }
    });
  },
  click(e) {
    if (!this.isPopupRoomsOfGuestFastbooking(e) || !this.isAccordionOfAddAdultsAndChilds(e) || bcl.c.fastbooking.rooms.validateChildsSelects()) {
      this.continueProcess(e);
    }
  },

  continueProcess(e) {
    if (!bcl.u.containsClass(e.currentTarget, this.props.cssSelectorPD)) {
      e.preventDefault();
    }
    const $anchor = e.target.tagName === "A" ? e.target : e.target.closest("a");
    if ($anchor?.id) {
      window.location.href = `#${$anchor.id}`;
    }
    const parent = e.currentTarget.closest(this.props.cssSelectorItem);
    if (bcl.u.containsClass(parent, "mod--v-menu") && !bcl.u.mobile.isMobile()) {
      return;
    }
    this.processClick(e.currentTarget);
    if (e.currentTarget.closest(".c-fastbooking__submenu-rooms")) {
      const $container = e.currentTarget.closest(".c-fastbooking__submenu-rooms");
      setTimeout(() => {
        bcl.s.tabs.cleanAndSetStylePopFbDialog($container);
      }, 507);
    }
  },

  isPopupRoomsOfGuestFastbooking(e) {
    return e.currentTarget.closest(".c-fastbooking__submenu-rooms");
  },

  isAccordionOfAddAdultsAndChilds(e) {
    return bcl.u.findClosestNodeWithClass(e.currentTarget, "accordion-item-add-child-JS");
  },

  processClick($node) {
    const $content = $node.parentNode.querySelector("." + this.props.cssSelectorContent);
    const $parent = $node.closest(this.props.cssSelectorItem);
    if ($content) {
      this.setHeightContent($content, $parent);
    }
    this.toggle($parent, $node);
    this.toogleFocusHidden($parent, $content);
  },

  closeAll($container) {
    $container.querySelectorAll(`.accordion-item.${this.props.classNameActive}`).forEach(($accordionItem) => {
      this.setHeightContent($accordionItem.querySelector("." + this.props.cssSelectorContent), $accordionItem);
      bcl.u.removeClass($accordionItem, this.props.classNameActive);
      const $content = $accordionItem.querySelector("." + this.props.cssSelectorContent);
      if ($content) {
        this.toogleFocusHidden($accordionItem, $content);
      }
    });
  },

  toggle($item, $node) {
    if (!$item) {
      return;
    }
    bcl.u.toggleClass($item, this.props.classNameActive);
    if ($node) {
      $node.setAttribute("aria-expanded", bcl.u.containsClass($item, this.props.classNameActive) ? "true" : "false");
    }
  },
  // PLASOFT-21682: Ensure content has aria-hidden and is hidden when the accordion is closed to prevent tab navigation to hidden elements
  toogleFocusHidden($parent, $content) {
    if (!parent || !$content) {
      return;
    }
    if (bcl.u.containsClass($parent, this.props.classNameActive)) {
      $content.removeAttribute("aria-hidden");
      bcl.u.getFocusableElements($content, true)?.forEach(($focusable) => {
        //TO avoid unwanted focus, only check already controlled elements
        if ($focusable.hasAttribute("tabindex")) {
          $focusable.setAttribute("tabindex", "0");
        }
      });
    } else {
      $content.setAttribute("aria-hidden", "true");
      bcl.u.getFocusableElements($content, true)?.forEach(($focusable) => {
        //TO avoid unwanted focus, only check already controlled elements
        if ($focusable.hasAttribute("tabindex")) {
          $focusable.setAttribute("tabindex", "-1");
        }
      });
    }
  },
  setHeightContent($item, parent) {
    if (!$item) {
      return;
    }
    $item.style.height = `${$item.scrollHeight}px`;
    setTimeout(
      () => {
        $item.style.height = "";
      },
      bcl.u.containsClass(parent, this.props.classNameActive) ? 10 : 501,
    );
  },

  resize() {
    document.querySelectorAll(".accordion-item.mod--v-menu").forEach(($accordionItem) => {
      const method = bcl.u.mobile.isMobile() ? "removeClass" : "addClass";
      bcl.u[method]($accordionItem, this.props.classNameActive);
    });
  },
};

export default accordion;
